import { map, size } from "lodash";
import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import { arrayWithNEmptyItems } from "../../../../utils/array";
import {
  formatNumber,
  formatUpperCase,
  formatPhoneWithDdd,
} from "../../../../utils/formats";
import { Label, Text } from "../styles";

const EnderecoSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    cep,
    endereco,
    enderecoNumero,
    complemento,
    bairro,
    nomeCidade,
    uf,
    pais,
    tipoPessoa,
    email,
    dddTelefone,
    telefone,
    dddCelular,
    celular,
  } = props;

  const isPJ = tipoPessoa?.toUpperCase() === "J";

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Input
            label="CEP"
            value={cep}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={8}>
          <Input
            label="Endereço"
            value={formatUpperCase(endereco)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Número"
            value={enderecoNumero}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Complemento"
            value={formatUpperCase(complemento)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Bairro"
            value={formatUpperCase(bairro)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Cidade"
            value={formatUpperCase(nomeCidade)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="UF"
            value={uf}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="País"
            value={formatUpperCase(pais)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={8}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Tipo de residência"
            value=""
          />
        </Grid>
        {isPJ && (
          <>
            <Grid item md={4}>
              <Input
                label="Telefone"
                value={formatPhoneWithDdd(dddTelefone, telefone)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Celular"
                value={formatPhoneWithDdd(dddCelular, celular)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="E-mail"
                value={formatUpperCase(email)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default EnderecoSection;
